import { useState } from "react";

export default function useToken() {
  const getToken = () => {
    const tokenString = sessionStorage.getItem("AccessToken");
    return tokenString;
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken) => {
    sessionStorage.setItem("AccessToken", userToken);
    setToken(userToken);
  };

  const clearToken = () => {
    sessionStorage.removeItem("AccessToken");
    localStorage.clear();
  };

  return {
    setToken: saveToken,
    token,
    clearToken,
  };
}
